export const PERMISOS = {
  FALLECIDOS: {
    CARGAR_ARCHIVO: "FALLECIDOS.CARGAR_ARCHIVO",
    CONSULTAR_PACIENTE: "FALLECIDOS.CONSULTAR_PACIENTE",
    VER_CARGA_ARCHIVO: "FALLECIDOS.VER_CARGA_ARCHIVO",
  },
};
